import React, { useEffect, useState } from "react";
import { NavDropdown, MenuItem } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import NoDemoLink from "../../../../../components/controllers/shared/tooltip/noDemoLink";
import { useGlobalContext } from "../../../../../context/global/state";
import { convertUrl } from "./helpers/helpers";
import Style from "./styles/style";

type SecondaryNavDropdownProps = {
	index: number;
	title: string;
	navigationTopic: any;
	role: string;
};
const SecondaryNavDropdown: React.FC<SecondaryNavDropdownProps> = ({
	index,
	title,
	role,
	navigationTopic,
}) => {
	const [active, setActive] = useState(false);
	const [highlighted, setHighlighted] = useState(false);
	const { state, dispatch } = useGlobalContext();
	const history = useHistory();
	const activeClass = highlighted ? "active" : "";

	// Set active to false when user leaves page
	useEffect(() => {
		const cleanupListen = history.listen((event) => {
			setActive(false);
		});
		return () => {
			cleanupListen();
		};
	}, [history, dispatch]);

	useEffect(() => {
		return () => {
			const isActiveLink = navigationTopic.some((item) => {
				const isActiveLink =
					item.linkText === state.pageContext.activeLink;

				const navUrl = item.url.replace("#", "");
				const pathname = history.location.pathname;
				const navMatchesPage = navUrl === pathname;

				const navExperience = navUrl.split("/")[2] ?? "nav";
				const pathExperience = pathname.split("/")[2] ?? "path";

				const anyMatch =
					isActiveLink ||
					navMatchesPage ||
					navExperience === pathExperience;
				return anyMatch;
			});

			setHighlighted(isActiveLink);
		};
	}, [state, navigationTopic, history.location.pathname]);

	return (
		<>
			<Style />
			<NavDropdown
				title={title}
				id={`nav-drop-${index}`}
				open={active}
				onToggle={(event) => setActive(!active)}
				className={`nodemo-secondary-sub-dropdown ${activeClass}`}
				noCaret
			>
				{navigationTopic.map((item, index) => {
					const isNoDemo = item.url === "#no-demo";
					const url = convertUrl(item);
					const pathname = `#${history.location.pathname}`;
					const subNavMatch = pathname === url;
					const isActiveLink =
						item.linkText === state.pageContext.activeLink;
					const subNavClass =
						subNavMatch || isActiveLink ? "active" : "";

					// Link elements
					const noDemoLink = (
						<li role={role}>
							<NoDemoLink block={true}>
								<button className="btn btn-nodemo-secondary">
									<span>{item.linkText}</span>
								</button>
							</NoDemoLink>
						</li>
					);
					const link = (
						<MenuItem
							href={url}
							className={subNavClass}
							onSelect={() => setActive(!active)}
						>
							{item.linkText}
						</MenuItem>
					);

					return (
						<React.Fragment key={`nav-${index}`}>
							{isNoDemo ? noDemoLink : link}
						</React.Fragment>
					);
				})}
			</NavDropdown>
		</>
	);
};

export default SecondaryNavDropdown;
